import { Flex, Spinner } from '@chakra-ui/react';
import React, { PropsWithChildren, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export const RequireEmailVerification: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { isEmailVerified, loading, setLoading } = useAuth();
  const location = useLocation();

  // Reset loading state when component mounts/unmounts
  useEffect(() => {
    setLoading(false);
    return () => setLoading(false);
  }, [setLoading]);

  // Show spinner while auth loading
  if (loading) {
    return (
      <Flex
        width="full"
        height="full"
        minHeight="600px"
        alignItems="center"
        justifyContent="center"
      >
        <Spinner />
      </Flex>
    );
  }

  // If not verified, redirect to verification page
  if (!isEmailVerified) {
    return <Navigate to="/verify-email" state={{ from: location }} replace />;
  }

  // User is verified, render children
  return <>{children}</>;
};
